import React, { Fragment, useState } from "react";
import { DocumentService } from "../../../../services/document/document.service";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../../helper/dateTimeHelper";
import { useSelector } from "../../../../store/store";
import { getEnv } from "../../../../AppConfigs";
import { mailRegexs } from "../../../../constants/mailTemplateConstants";
import { MailService } from "../../../../services/mail/mail.service";
import { Button } from "antd";

export const EditorFinish = (props: any) => {
  const { document, user } = props;
  const docEditors = document.docEditors ? JSON.parse(document.docEditors) : [];
  const newDocEditors = docEditors.map((e: any) => ({
    ...e,
    isDone: e.isDone || false,
    date: e.date ? new Date(e.date) : null,
  }));
  const [numEdited, setNumEdited] = useState(newDocEditors.filter((e: any) => e.isDone).length);
  const currentUserIndex = newDocEditors.findIndex((e: any) => e.email === user?.current?.username?.toLowerCase());
  const isDoneCompose = newDocEditors[currentUserIndex]?.isDone;
  const isOwner = document.userEmail === user?.current?.username.toLowerCase();
  const [isFinish, setIsFinish] = useState(!!isDoneCompose);
  const detailUrl = getEnv("REACT_APP_DOCUMENT_DETAILS_URL");
  const mailtemplates = useSelector((state: any) => state.systemMgmt.mailtemplates);

  const handleFinish = async () => {
    setIsFinish(true);
    setNumEdited(numEdited + 1);
    if (currentUserIndex !== -1) {
      newDocEditors[currentUserIndex].isDone = true;
      newDocEditors[currentUserIndex].date = new Date();
      const fields = {
        docEditors: JSON.stringify(newDocEditors),
      };
      await DocumentService.updateFileInfo(document.id, fields);
      sendMail();
    }
  };

  const renderEditorsTitle = (): string => {
    const getIconFinish = (isDone: boolean) => (isDone ? " ✔" : " 💬");
    const dateComplete = (date: any) => (date ? `(${getDDMMYYYFormat(date)} - ${getHHmmFormat(date)})` : "");
    const titleTextArr = newDocEditors.map((e: any) => e.displayName + getIconFinish(e.isDone) + dateComplete(e.date));
    titleTextArr.reverse();
    return titleTextArr.join("\n");
  };

  const sendMail = () => {
    let url = `${detailUrl}/${document?.listItemId}?fileId=${document?.fileId}&action=file`;
    const template = mailtemplates.find((m: any) => m.eMailType === "EDCC");
    const subject = template.eSubject.replace("{0}", document?.Title || "").replace("{1}", "soạn thảo");
    const content = template.eContent
      .replace(mailRegexs.zero + ";", document?.docCode || "")
      .replace(mailRegexs.one + ";", document?.Title || "")
      .replace(mailRegexs.two + ";", user?.current?.name || "")
      .replace(mailRegexs.three + ";", user?.current?.name || "")
      .replace(mailRegexs.four + ";", user?.current?.username || "")
      .replace(mailRegexs.siteUrl2, url);
    MailService.sendMailByBotit({ content, subject, toMail: document.userEmail });
    // const message = MailService.buildMailMesssage(subject, content, "html", document.userEmail);
    // MailService.sendMail(message);
  };

  const isDisableButton = () => {
    if (isFinish) return true;
    if (currentUserIndex < 0) return true;
  };

  return (
    <Fragment>
      {((currentUserIndex !== -1 && document.docStatusId === 2) || isOwner) && (
        <>
          <div className="float-right d-flex column align-items-center" style={{ height: "40px" }}>
            <p title={renderEditorsTitle()} className="mx-2 mt-3">
              Số người thực hiện soạn thảo: {numEdited}/{newDocEditors.length}
            </p>
            <Button
              onClick={handleFinish}
              title="Anh/Chị vui lòng xác nhận sau khi hoàn tất."
              type="primary"
              disabled={isDisableButton()}
              hidden={currentUserIndex < 0}
            >
              {isFinish ? "Anh/Chị đã xác nhận hoàn tất soạn thảo" : "Hoàn tất soạn thảo"}
            </Button>
          </div>
          <hr style={{ width: "100%", marginTop: "50px" }} />
        </>
      )}
    </Fragment>
  );
};
